module.exports = __webpack_public_path__ + "img/vallone-exalt-tooltips-configurator-06.a0c3d30f.jpg";